<template>
  <div :style="rootStyle" :class="isRoot ? 'root-menu' : ''">
    <el-menu-item v-if="visibleItem.isLeaf" :index="visibleItem.fullPath">
      <router-link :target="linkTarget" :to="visibleItem.fullPath">
        <menu-text-item :is-root="isRoot" :icon="visibleItem.meta.icon"
                        :title="visibleItem.meta.title"></menu-text-item>
      </router-link>
    </el-menu-item>

    <el-submenu v-else :index="visibleItem.fullPath">
      <template #title>
        <menu-text-item style="font-weight: 500; height: 68px; line-height: 68px" :is-root="isRoot"
                        :icon="visibleItem.meta.icon" :title="visibleItem.meta.title"></menu-text-item>
      </template>
      <menu-item v-for="child of visibleItem.children"
                 :key="child.path"
                 :item="child"
                 :base-path="visibleItem.fullPath"/>
    </el-submenu>
  </div>
</template>

<script>
  import path from 'path'
  import MenuTextItem from '@/layout/menu/MeunTextItem'

  export default {
    name: 'MenuItem',
    components: { MenuTextItem },
    props: {
      item: {
        type: Object,
        required: true
      },
      basePath: {
        type: String,
        required: true
      },
      isRoot: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      visibleItem () {
        const ret = this.$_.cloneDeep(this.item)
        ret.isLeaf = !ret.children
        ret.fullPath = path.resolve(this.basePath, ret.path)
        return ret
      },
      rootStyle () {
        return {
          display: this.isRoot ? 'inline-block' : 'block'
        }
      },
      linkTarget () {
        return process.env.VUE_APP_LINK_TARGET
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/
  a,
  a:focus,
  a:hover {
    outline: none;
    cursor: pointer;
    color: inherit;
    text-decoration: none;
  }

  /deep/ .el-submenu__title {
    height: 100%;
    padding-left: 5px;
    padding-right: 8px;
  }

  /deep/ .el-submenu__icon-arrow, .el-icon-arrow-down {
    display: none !important;
  }
</style>
